export default {
  translation: {
    nav: {
      home: 'Главная',
      trips: 'Путешествия',
      aboutUs: 'О нас',
      alerts: 'Уведомления',
      wishlist: 'Избранное',
      language: 'Язык',
      profile: 'Профиль',
      settings: 'Настройки',
      signIn: 'Войти',
      signUp: 'Регистрация'
    },
    hero: {
      title: 'Исследуйте Уганду',
      subtitle: 'и не только',
      description: 'Откройте для себя Жемчужину Африки с опытными местными гидами. Незабываемые впечатления ждут вас среди захватывающих пейзажей и яркой культуры Уганды.',
      searchPlaceholder: 'Куда вы хотите поехать?',
      categories: {
        all: 'Все',
        wildlife: 'Дикая природа',
        safari: 'Сафари',
        cultural: 'Культура',
        adventure: 'Приключения',
        birding: 'Наблюдение за птицами'
      }
    },
    common: {
      from: 'от',
      reviews: 'отзывов',
      viewMore: 'Показать больше',
      book: 'Забронировать',
      seeAll: 'Показать все',
      loading: 'Загрузка...'
    }
  }
};